import React, { Component } from "react";
import { FormGroup, Label, Col, Container, Row, Collapse, CardBody, Card, Button, ButtonGroup } from "reactstrap";
import BusSteppers from "./busSteppers";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import PriceFormatter from '../../components/misc/PriceFormatter';
import * as moment from 'moment';
// import 'moment-timezone';
import { ALIBABA_URL } from "../../config/Config";
import axios from "axios";
import SaveLoader from "../../components/loader/SaveLoader";
import { ACCESS_TOKEN } from "../../redux/actions/setting";
import BusItem from "./BusItem";
import { ALL_BUS_STATIONS } from "./BusConfig"
import BusSearchBanner from "../../components/banner/BusSearch"
import Checkbox from '@material-ui/core/Checkbox';
import { busCompany } from '../../config/busCompany';

class BusSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            busTicket: [],
            busSearch: this.props.busSearch,
            loading: false,
            showSearch: false,
            searchresult: [],
            sortBy: null,//price - time
            sortASC: true,//asc - desc
            timefilter: true,
            airlinefilter: true,
            time1: true,
            time2: true,
            time3: true,
            time4: true,
            companise: [],
            prev_serach_company: [],
            prev_serach_time: [],
        }
        this.filterbusticket = this.filterbusticket.bind(this);
    }

    async componentDidMount() {
        let { busSearch } = this.state;
        this.setState({ loading: true })
        const access_token = localStorage.getItem(ACCESS_TOKEN);
        const options = {
            method: 'POST',
            headers: {
                'X-ZUMO-AUTH': access_token,
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(busSearch),
            url: ALIBABA_URL + 'Bus/Get',
        };

        const get_discont = await axios(options);
        console.log(get_discont)
        if (get_discont.status < 200 || get_discont.status > 300) {
            const error = new Error(get_discont.statusText);
            error.get_discont = get_discont;
            console.log(error);
            this.setState({ loading: false })
        } else {
            busSearch = get_discont.data.data.busTrips;
            const companise = [];
            const faCompanise = []
            busSearch.map(item => {
                if (faCompanise.length === 0) {
                    faCompanise.push({ companyName: item.companyName, companyCode: item.companyCode })
                }
                else if (faCompanise.filter(i => i.companyName === item.companyName).length === 0)
                    faCompanise.push({ companyName: item.companyName, companyCode: item.companyCode })
                return true;
            }
            )
            // console.log(faCompanise);
            faCompanise.map(bus => {
                let enbus;
                if (busCompany.filter(i => i.fa === bus.companyName).length !== 0) {
                    enbus = busCompany.filter(i => i.fa === bus.companyName)[0].en
                    // console.log(enbus);
                    companise.push({ companyName: enbus, companyCode: bus.companyCode });
                } else { 
                    companise.push({ companyName: bus.companyName, companyCode: bus.companyCode });

                }
                return true;
            }
            )

            await this.setState({
                loading: false,
                searchresult: busSearch,
                busSearch,
                companise
            })
        }

    }
    async filterbusticket(e) {
        const { prev_serach_company, busSearch, prev_serach_time } = this.state;
        let companies = [];
        let FinalCompany = [];
        let time_array = [];
        let times = [];
        if (e === 'time') {
            prev_serach_time.map(ptime => {
                switch (ptime) {
                    case 'time1':
                        time_array.push({ "start": "00:00", "end": "8:00" });
                        break;
                    case 'time2':
                        time_array.push({ "start": "8:00", "end": "12:00" });
                        break;
                    case 'time3':
                        time_array.push({ "start": "12:00", "end": "20:00" });
                        break;
                    case 'time4':
                        time_array.push({ "start": "20:00", "end": "24:00" });
                        break;
                    default:
                        return true;
                }
                return true;
            });

            if (prev_serach_company.length !== 0) {
                //push ticket where company and time is equal to selected time;
                prev_serach_company.map(val => {
                    companies.push(busSearch.filter(item => item.companyName === val));
                    companies.map(company => {
                        company.map(item => {
                            let departureDate = moment(item.departureDateTime).format('HH:mm');
                            // console.log(departureDate);
                            for (let i = 0; i < time_array.length; i++) {
                                let compare = (moment(departureDate, "HH:mm") > moment(time_array[i].start, "HH:mm")) && (moment(departureDate, "HH:mm") <= moment(time_array[i].end, "HH:mm"));
                                if (compare) {
                                    times.push(item);
                                }
                            }
                            this.setState({ searchresult: times });
                            return true;
                        });
                        return true;
                    });
                    return true;
                });
            } else {
                //push ticket where time is equal to selected time;
                busSearch.map(item => {
                    let departureDate = moment(item.departureDateTime).format('HH:mm');
                    // console.log(departureDate);
                    for (let i = 0; i < time_array.length; i++) {
                        let compare = (moment(departureDate, "HH:mm") > moment(time_array[i].start, "HH:mm")) && (moment(departureDate, "HH:mm") <= moment(time_array[i].end, "HH:mm"));
                        if (compare) {
                            times.push(item);
                        }
                    }
                    return true;
                });
                await this.setState({ searchresult: times });
            }
        }
        else {
            // console.log('company')
            prev_serach_company.map(val => {
                companies.push(busSearch.filter(item => item.companyName === val));
                return true;
            });
            if (prev_serach_time.length !== 0) {
                //push ticket where time is equal to selected time;
                prev_serach_time.map(ptime => {
                    switch (ptime) {
                        case 'time1':
                            time_array.push({ "start": "00:00", "end": "8:00" });
                            break;
                        case 'time2':
                            time_array.push({ "start": "8:00", "end": "12:00" });
                            break;
                        case 'time3':
                            time_array.push({ "start": "12:00", "end": "20:00" });
                            break;
                        case 'time4':
                            time_array.push({ "start": "20:00", "end": "24:00" });
                            break;
                        default:
                            return true;
                    }
                    return true;
                });
                companies.map(company => {
                    company.map(item => {
                        let departureDate = moment(item.departureDateTime).format('HH:mm');
                        // console.log(departureDate);
                        for (let i = 0; i < time_array.length; i++) {
                            let compare = (moment(departureDate, "HH:mm") > moment(time_array[i].start, "HH:mm")) && (moment(departureDate, "HH:mm") <= moment(time_array[i].end, "HH:mm"));
                            if (compare) {
                                times.push(item);
                            }
                        }
                        this.setState({ searchresult: times });
                        return true;
                    });
                    return true;
                });


            } else {
                companies.map(company => {
                    company.map(ticket => {
                        FinalCompany.push(ticket);
                        return true;
                    });
                    return true;
                });
                await this.setState({ searchresult: FinalCompany });
            }
        }
        // console.log(FinalCompany);
    }

    async handelTime(newtime) {
        const { prev_serach_time, busSearch } = this.state;
        let time = {};
        const allfalse = { time1: false, time2: false, time3: false, time4: false };
        const alltrue = { time1: true, time2: true, time3: true, time4: true };

        if (prev_serach_time.filter((item) => item === newtime).length !== 0) {
            let index = prev_serach_time.indexOf(newtime);
            prev_serach_time.splice(index, 1);
            if (prev_serach_time.length === 0) {
                time = alltrue;
                await this.setState({ searchresult: busSearch });
            } else {
                time = allfalse;
                prev_serach_time.map(ptime => time[ptime] = true);
                this.filterbusticket('time');
            }
            await this.setState(time)
        } else {
            prev_serach_time.push(newtime);
            if (prev_serach_time.length === 4) {
                time = alltrue;
                this.setState({ prev_serach_time: [] });
                await this.setState({ searchresult: busSearch });
            } else {
                time = allfalse;
                prev_serach_time.map(ptime => time[ptime] = true);
                this.filterbusticket('time');
            }
            await this.setState(time);
        }
    }

    async handleToggle(e) {
        const { prev_serach_company, busSearch } = this.state;
        if (prev_serach_company.filter((i) => i === e).length === 0) {
            await prev_serach_company.push(e);
            this.filterbusticket();
        } else {
            let index = prev_serach_company.indexOf(e);
            prev_serach_company.splice(index, 1);
            if (prev_serach_company.length === 0) {
                const searchresult = busSearch;
                await this.setState({ searchresult });
            } else {
                this.filterbusticket('company');
            }
        }
    }
    async handelSort(sortBy) {
        // console.log(sortBy);
        const searchresult = this.state.searchresult;
        // console.log(moment(searchresult[0].departureDateTime).format('HH:mm'));

        let sortASC = true;
        if (this.state.sortBy === sortBy) {
            sortASC = !this.state.sortASC;
        }
        this.setState({ sortASC, sortBy });
        if (sortBy === 'price') {
            searchresult.sort((a, b) => parseFloat(a.totalPrice) - parseFloat(b.totalPrice));
        }
        else {
            //time
            searchresult.sort((a, b) => new Date(a.departureDateTime) - new Date(b.departureDateTime));
        }

        if (!sortASC) {
            searchresult.reverse();
        }
    }

    // compareTime(a, b) {
    //     let aTime = moment(a.departureDateTime).format('HH:mm');
    //     let bTime = moment(b.departureDateTime).format('HH:mm');

    //     let comparison = 0;
    //     if (moment(aTime) > moment(bTime)) {
    //         comparison = 1;
    //     } else if (moment(aTime) < moment(bTime)) {
    //         comparison = -1;
    //     }
    //     return comparison;
    // }


    render() {
        const { searchresult } = this.state;
        const { busSearch } = this.props;
        // console.log(busSearch);
        // console.log(searchresult);
        // console.log(JSON.stringify(searchresult, null, 2))

        return (
            <div className="pt-5 mt-5" >
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Container className="min-height-500">
                    <Row>
                        <Col>
                            <div className="collsapse-bokk-ticket">
                                <div className="today-and-search-again">
                                    <div className="your-selection-city-date">
                                        <span className="your-selection-city-date-from">From :
                                                 &nbsp;{ALL_BUS_STATIONS.filter(i => i.value === busSearch.OriginStationCode)[0].label}
                                        </span>
                                        <span className="your-selection-city-date-to" >To : &nbsp; {ALL_BUS_STATIONS.filter(i => i.value === busSearch.DestinationStationCode)[0].label} </span>
                                        <span className="your-selection-city-date-date" >Date : &nbsp; {busSearch.DepartureDate} </span>
                                    </div>
                                    <div className="your-selection-city-date-but">
                                        <Button block outline color="secondary" className='search-again-but' onClick={() => this.setState({ showSearch: !this.state.showSearch })}>
                                            {!this.state.showSearch ? "Search Again" : "Hide Search"}
                                        </Button>
                                    </div>
                                </div>
                                <Collapse isOpen={this.state.showSearch}>
                                    <Card className='search-again-card'>
                                        <CardBody  >
                                            <BusSearchBanner />
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <BusSteppers active={0} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='3' sm='12' className="filter-left-sidebar">
                            <div className="panel panel-default sidebar-menu box p-3 pt-4" >
                                <div className="panel-body">
                                    <div className="category-title pb-1">
                                        <Card className="filter-title-collapse">
                                            <CardBody>
                                                <h6 onClick={() => this.setState(prestate => ({ timefilter: !prestate.timefilter }))}> Time to travel :</h6>
                                            </CardBody>
                                        </Card>
                                        <Collapse isOpen={this.state.timefilter} className="collapse-filter-body">
                                            <Card>
                                                <CardBody>
                                                    <div className="w-100 d-flex filter-flight-time">
                                                        <Button outline color="secondary" className={this.state.time1 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelTime
                                                            .bind(this, "time1")
                                                        }><span className="time-travel-span">0 to 8 </span><br />AM</Button>
                                                        <Button outline color="secondary" className={this.state.time2 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelTime
                                                            .bind(this, "time2")
                                                        }><span className="time-travel-span">8 to 12 </span><br />AM</Button>
                                                        <Button outline color="secondary" className={this.state.time3 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelTime
                                                            .bind(this, "time3")
                                                        }><span className="time-travel-span">12 to 20</span> <br />PM</Button>
                                                        <Button outline color="secondary" className={this.state.time4 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelTime
                                                            .bind(this, "time4")
                                                        }><span className="time-travel-span">20 to 24</span> <br />PM</Button>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                        <Card className="filter-title-collapse">
                                            <CardBody>
                                                <h6 onClick={() => this.setState(prestate => ({ airlinefilter: !prestate.airlinefilter }))}>Bus Company :</h6>
                                            </CardBody>
                                        </Card>
                                        <Collapse isOpen={this.state.airlinefilter} className="collapse-filter-body bus-company-list">
                                            <Card>
                                                <CardBody>
                                                    <div className="w-100 ">

                                                        {this.state.companise.map((company, i) =>
                                                            <FormGroup check key={i} style={{ paddingLeft: 0 }} >
                                                                <Label check>
                                                                    <Checkbox
                                                                        // color="default"
                                                                        onChange={this.handleToggle
                                                                            .bind(this, company.companyName)
                                                                        }
                                                                    // checked={this.state.airlines !== -1}
                                                                    />
                                                                    <img src={`/assets/images/bus/${company.companyCode}.jpg`} alt={company.companyName} className='filter-icon' />
                                                                    {company.companyName}
                                                                </Label>
                                                            </FormGroup>
                                                        )}
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                    </div>
                                </div>

                            </div>
                        </Col>
                        <Col md='9' sm='12' >
                            <div className='white box mb-3 w-100'>
                                <Col className='pt-2 pb-2'>
                                    <div className='d-flex justify-content-between w-100 search-filter-bar'>
                                        <span>{searchresult.length} Bus(es) find.</span>

                                        <ButtonGroup>
                                            <Button outline color="secondary" className={(this.state.sortBy === "price") ? "activeSort" : "inactiveSort"} onClick={this.handelSort
                                                .bind(this, "price")
                                            }>
                                                <i className={(this.state.sortBy === "price" && this.state.sortASC) ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc"} /> Price
                                            </Button>

                                            <Button outline color="secondary" className={(this.state.sortBy === "time") ? "activeSort" : "inactiveSort"} onClick={this.handelSort
                                                .bind(this, "time")
                                            }>
                                                <i className={(this.state.sortBy === "time" && this.state.sortASC) ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc"} /> Bus time
                                            </Button>
                                        </ButtonGroup>

                                        <ButtonGroup>
                                            <Button outline color="secondary" onClick={this.handelChangeDate
                                                // .bind(this, moment(busSearch.DepartureDate, 'YYYY MM DD').add(-1, 'days').format("YYYY-MM-DD"))
                                            }
                                            >
                                                <i className="la la-chevron-left" />

                                                {moment(busSearch.DepartureDate, 'YYYY MM DD').add(-1, 'days').format("YYYY-MM-DD")}
                                            </Button>
                                            <Button disabled outline color="secondary" >{busSearch.DepartureDate}</Button>
                                            <Button outline color="secondary" onClick={this.handelChangeDate
                                                // .bind(this, moment(busSearch.DepartureDate, 'YYYY MM DD').add(1, 'days').format("YYYY-MM-DD"))
                                            }>
                                                {moment(busSearch.DepartureDate, 'YYYY MM DD').add(1, 'days').format("YYYY-MM-DD")}
                                                <i className="la la-chevron-right" />
                                            </Button>
                                        </ButtonGroup>

                                    </div>
                                </Col>

                            </div>
                            {searchresult.map((item, i) => {
                                const orgin = ALL_BUS_STATIONS.filter(i => i.value === item.orginStationCode)[0].label
                                const destination = ALL_BUS_STATIONS.filter(i => i.value === item.destinationStationCode)[0].label;


                                return (
                                    <BusItem key={i} item={item} destination={destination}
                                        orgin={orgin}
                                    />
                                )
                            }
                            )}
                        </Col>
                    </Row>

                </Container>

            </div>
        )

    }

}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        busSearch: state.busSearch,
    }
};

// const mapDispatchToProps = dispatch => {
//     return {
//         setSearch: search => {
//             dispatch(setSearch(search))
//         }
//     }
// };

export default connect(mapStateToProps, null)(BusSearch)


// WEBPACK FOOTER //
// ./src/containers/bus/bus-search.jsx